import { jsx as _jsx } from "react/jsx-runtime";
import UnknownComponent from '../components/common/UnknownComponent';
import AssetsListSection from '../components/sections/AssetsListSection';
import CarouselBanner from '../components/sections/CarouselBanner';
import FAQ from '../components/sections/Faq';
import GroupOf2 from '../components/sections/GroupOf2';
import HubspotContainer from '../components/sections/HubspotForm';
import Intro from '../components/sections/Intro';
import ItemsList from '../components/sections/ItemsList';
import StatisticColumns from '../components/sections/StatisticColumns';
import Steps from '../components/sections/Steps';
export const componentRegistry = {
    plainIntroComponent: Intro,
    stepsComponent: Steps,
    faqComponent: FAQ,
    bannerComponent: null,
    tableContainer: null,
    featuredLogosComponent: null,
    footerMenuColumnComponent: ItemsList,
    groupOf2Component: GroupOf2,
    assetsListComponent: AssetsListSection,
    scrollingBanner: CarouselBanner,
    statisticColumnsComponent: StatisticColumns,
    hubspotComponent: HubspotContainer,
};
export const renderComponent = (component, nested, additionalFields) => {
    var _a, _b, _c, _d;
    const type = (_d = (_c = (_b = (_a = component === null || component === void 0 ? void 0 : component.sys) === null || _a === void 0 ? void 0 : _a.contentType) === null || _b === void 0 ? void 0 : _b.sys) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : 'unknown';
    const Component = componentRegistry[type];
    if (Component) {
        const props = {
            entryId: component.sys.id,
            componentType: type,
            nested,
        };
        if ((type === 'hubspotComponent' || type === 'groupOf2Component') &&
            additionalFields) {
            props.additionalFields = additionalFields;
        }
        return _jsx(Component, Object.assign({}, props), component.sys.id);
    }
    return (_jsx(UnknownComponent, { type: type, component: component }, component.sys.id));
};
